export type BuildPurposeValue =
  | 'HomeDefense'
  | 'Competition'
  | 'Range'
  | 'Hunting'
  | 'Collection'

export const BUILD_PURPOSE_OPTIONS: { value: BuildPurposeValue | ''; label: string }[] = [
  { value: '', label: 'Not specified' },
  { value: 'HomeDefense', label: 'Home defense' },
  { value: 'Competition', label: 'Competition' },
  { value: 'Range', label: 'Range / plinking' },
  { value: 'Hunting', label: 'Hunting' },
  { value: 'Collection', label: 'Collection' }
]

const LABELS: Record<BuildPurposeValue, string> = {
  HomeDefense: 'Home defense',
  Competition: 'Competition',
  Range: 'Range / plinking',
  Hunting: 'Hunting',
  Collection: 'Collection'
}

export function buildPurposeLabel (purpose?: string | null): string | null {
  if (!purpose || purpose === 'None') return null
  return LABELS[purpose as BuildPurposeValue] ?? purpose
}
